import { PRODUCTO_LINEA } from "./constants";

const getURLFromImageBackground = (content) => {
  return content.find(item => item.url).url;
}

const formatUrl = (url) => {
  let formattedUrl = url.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); 
  formattedUrl = formattedUrl.replace(/[|/ _]/g, '-').replace(/--+/g, '-');
  if (formattedUrl.endsWith('-')) {
    formattedUrl = formattedUrl.slice(0, -1);
  }

  return formattedUrl.toLowerCase();
}

const formatDescription = (description) => {
  const maxLength = 155;
  if (description?.length <= maxLength) {
    return description;
  }
  const lastPeriodIndex = description?.lastIndexOf('.', maxLength);
  const truncatedDescription = description?.slice(0, lastPeriodIndex);
  return `${truncatedDescription}.`;
}

const URLTypeProduct = (type) => {
  return type === PRODUCTO_LINEA ? 'producto' : 'producto-especial';
}

export {
  getURLFromImageBackground,
  formatUrl,
  formatDescription,
  URLTypeProduct,
};
